<template>
  <div class="bank-list-view">
    <header class="m-header flexsb">
      <div class="left flexa">
        <span>合計費用：</span>
        <span class="amount">{{ amount }}</span>
        <span>{{ currency }}</span>
      </div>
      <div class="right flexa">
        <span>需支付：</span>
        <span class="amount">{{ amount }}</span>
        <el-select
          v-model="currency"
          placeholder="請選擇"
          style="width: 100px"
          @change="getAmount"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </header>
    <article class="container">
      <!-- <header class="s-header">
        <span class="p-fw p-f14">中國大陸用戶、香港用戶，</span>
        <span class="p-f12">可選擇以下的充值方式</span>
        <i class="pipe"></i>
      </header>
      <div class="bank-list">
        <div class="item" style="margin-left: 24px" @click="wxPay">
          <img src="@/assets/images/bank/logo/wx.png" height="24" />
          <span>微信支付</span>
        </div>
        <div class="item" @click="aliPay('ALIPAYCN')">
          <img src="@/assets/images/bank/logo/zfb.png" height="24" />
          <span>中国大陆支付宝</span>
        </div>
        <div class="item" @click="aliPay('ALIPAYHK')">
          <img src="@/assets/images/bank/logo/zfb.png" height="24" style="" />
          <span style="margin-left: 4px;">港澳台/境外支付宝</span>
        </div>
      </div> -->
      <header class="s-header" v-if="currency === 'CNY'">
        <span class="p-fw p-f14">中國大陸用戶，</span>
        <span class="p-f12">可選擇以下的充值方式</span>
        <i class="pipe"></i>
      </header>

      <!-- <div class="tips" v-if="currency === 'CNY'">
        <div>
          <span>快捷支付</span>
          <span>（無需開通網銀，雙重密碼保障，多重專享優惠）</span>
        </div>
        <div class="bank-list-card">
          <div
            v-for="(item, index) of bankListShow"
            :key="index"
            class="item"
            @click="selectCard(item)"
          >
            <img :src="item.imgUrl" alt="" />
            <span>{{ fakeCardNo(item.bank_acc_no_show) }}</span>
          </div>
        </div>
        <span class="link" @click="toAddNewCard">添加新卡></span>
      </div> -->
      <span v-if="currency === 'CNY'">網上銀行</span>
      <span v-if="currency === 'CNY'">（需要開通網銀，跳轉銀行頁面）</span>
      <div class="bank-list" v-if="currency === 'CNY'">
        <div class="bank-item" v-for="(item, index) of bankList" :key="index">
          <img
            :src="item.imgUrl"
            class="bank-img"
            alt
            height="42"
            @click="renew(item)"
          />
        </div>
      </div>
      <!-- <div class="bank-list" v-if="currency === 'CNY'">
        <div class="bank-item" @click="UMPay">
          <img src="@/assets/images/bank/logo/UMF.png" class="bank-img" alt />
        </div>
        <div class="flexa p-999 p-f12" style="margin-top: 10px;">(支持網上銀行，微信，支付寶等支付方式)</div>
      </div> -->
      <header class="s-header" style="margin-top: 20px">
        <span class="p-fw p-f14">香港用戶，</span>
        <span class="p-f12">可選擇以下的充值方式</span>
        <i class="pipe"></i>
      </header>
      <header class="t-header">FPS支付</header>
      <div class="bank-list">
        <div class="bank-item" @click="FPSPay">
          <img src="@/assets/images/bank/logo/FPS.png" class="bank-img" alt />
        </div>
        <div class="flexa p-999 p-f12" style="margin-top: 10px">
          (支持香港銀行或機構等支付方式)
        </div>
      </div>
    </article>
    <div v-html="test"></div>
    <el-dialog title="提示" :visible.sync="getVisible" width="30%">
      <span style="color: #333">
        您有未完成的購買申請，根據規則儘首次完成支付的購買申請能享受豁免卡費的優惠，其他購買申請支付時按原價格處理，請註意核實，謝謝；
        <!-- 您有未完成支付的購買申請，根據規則僅首次完成支付的購買申請能享受豁免卡費的優惠，其它購買申請支付時將按原價處理，請註意核實，謝謝； -->
        <br />如有疑問，請聯系我們：+86-4006183327或+852-31757797
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelOtherUnpayOrder">取消其他訂單</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >確 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
import { getUrlValue } from "@/utils/fun";
export default {
  data() {
    return {
      // 用於顯示高亮
      bankIndex: 0,
      // 卡類型 00 :實體卡 01：虛擬卡
      card_type: "",
      dialogVisible: false,
      bankListShow: [],
      imageList: [
        {
          id: "ABC",
          imgUrl: require(`../assets/images/bank/logo/103.png`)
        },
        { id: "BOC", imgUrl: require("../assets/images/bank/logo/104.png") },
        { id: "CCB", imgUrl: require("../assets/images/bank/logo/105.png") },
        { id: "CEB", imgUrl: require("../assets/images/bank/logo/303.png") },
        { id: "CIB", imgUrl: require("../assets/images/bank/logo/309.png") },
        { id: "CITIC", imgUrl: require("../assets/images/bank/logo/302.png") },
        { id: "CMB", imgUrl: require("../assets/images/bank/logo/308.png") },
        { id: "CMBC", imgUrl: require("../assets/images/bank/logo/305.png") },
        { id: "COMM", imgUrl: require("../assets/images/bank/logo/301.png") },
        { id: "GDB", imgUrl: require("../assets/images/bank/logo/306.png") },
        { id: "HXB", imgUrl: require("../assets/images/bank/logo/304.png") },
        { id: "ICBC", imgUrl: require("../assets/images/bank/logo/102.png") },
        { id: "PSBC", imgUrl: require("../assets/images/bank/logo/403.png") },
        { id: "SPAB", imgUrl: require("../assets/images/bank/logo/307.png") },
        { id: "SPDB", imgUrl: require("../assets/images/bank/logo/310.png") },
        {
          id: "SHB",
          imgUrl: require("../assets/images/bank/logo/SHB.png")
        },
        {
          id: "QDCCB",
          imgUrl: require("../assets/images/bank/logo/QDCCB.png")
        }
      ],
      order_no: "",
      options: [
        {
          value: "HKD"
        },
        {
          value: "CNY"
        }
      ],
      currency: "CNY",
      amountList: [{ amount: 0 }],
      amount: 0,
      bankList: [],
      test: "",
      return_url: "",
      priceData: {}
    };
  },
  computed: {
    fakeCardNo() {
      return (cardNo) => {
        return cardNo.slice(cardNo.length - 6);
      };
    },
    getVisible() {
      return this.dialogVisible && this.card_type === "00";
    }
  },
  mounted() {
    if (getUrlValue("order_no") || sessionStorage.getItem("order_no")) {
      this.order_no =
        getUrlValue("order_no") || sessionStorage.getItem("order_no");
      sessionStorage.setItem("order_no", this.order_no);
      this.getPrice();
      this.getMobileBank();
      sessionStorage.setItem("currency", this.currency);
      this.getBankList();
      // this.return_url = `https://172.20.34.102/cardshop/success?order_id=${this.order_no}`;
      this.return_url =
        process.env.NODE_ENV === "production"
          ? `https://merchant.globalcash.hk/cardshop/success?order_id=${this.order_no}`
          : process.env.NODE_ENV === "test"
          ? `https://172.20.34.102/cardshop/success?order_id=${this.order_no}`
          : `https://172.20.34.222/cardshop/success?order_id=${this.order_no}`;
    } else {
      this.$message({
        message: "訂單號丟失，請重新打開郵件鏈接！",
        type: "error"
      });
    }
  },
  methods: {
    async aliPay(iss_inst_code) {
      if (this.currency === 'CNY') {
        this.$message.error('暂时只支持港币')
        return
      }
      const params = {
        iss_inst_code,
        pay_type: "N101",
        channel_code: "ALLINPAYHK",
        pay_currency: this.currency,
        order_no: this.order_no,
        return_url: this.return_url
      };
      const res = await aPost2(api.moneyIn, params);
      if (res.data.errCode === "99999") {
        const data = res.data.retData;
        sessionStorage.setItem('qrcode', JSON.stringify(data.redirect_html))
        this.$router.push({
          path: "/aliPay",
          query: {
            // pay_info: data.pay_info,
            mer_order_no: data.mer_order_no,
            order_no: this.order_no
          }
        });
      }

    },
    async wxPay() {
      if (this.currency === 'CNY') {
        this.$message.error('暂时只支持港币')
        return
      }
      const params = {
        iss_inst_code: "WXPAY",
        pay_type: "N502",
        channel_code: "ALLINPAYHK",
        pay_currency: this.currency,
        order_no: this.order_no,
        return_url: this.return_url
      };
      const res = await aPost2(api.moneyIn, params);
      if (res.data.errCode === "99999") {
        const data = res.data.retData;
        this.$router.push({
          path: "/wxPay",
          query: {
            pay_info: data.pay_info,
            mer_order_no: data.mer_order_no,
            order_no: this.order_no
          }
        });
      }
    },
    /**
     * 获取手机号绑定的银行
     */
    async getMobileBank() {
      try {
        const res = await aPost2(api.queryUserBankCardList, {});
        if (!res) return;
        const data = res.data;
        if (data.errCode === "99999") {
          if (data.retData) {
            let list = data.retData.list;
            list.forEach((e) => {
              this.imageList.forEach((e2) => {
                if (e.iss_ins_code === e2.id) {
                  e.imgUrl = e2.imgUrl;
                }
              });
            });
            this.bankListShow = list;
          }
        } else {
          Message({
            message: data.errMsg || "ERROR",
            type: "error",
            duration: 2 * 1000
          });
        }
      } catch (error) {
        Message({
          message: error.errMsg || "ERROR",
          type: "error",
          duration: 2 * 1000
        });
      }
    },
    async selectCard(bankInfo) {
      sessionStorage.setItem("bankInfo", JSON.stringify(bankInfo));
      this.$router.push({ name: "fastPay" });
    },
    toAddNewCard() {
      this.$router.push({
        path: "/fastRegister",
        query: { order_no: this.order_no }
      });
    },
    async cancelOtherUnpayOrder() {
      let params = {
        order_no: this.order_no
      };
      let res = await aPost2(api.cancelOtherUnpayOrder, params);
      if (res.data.errCode === "99999") {
        this.dialogVisible = false;
        this.$message.success("取消成功");
      }
    },
    async getPrice() {
      let res = await aPost2(api.queryPrice, { order_no: this.order_no });
      if (res.data.errCode === "99999") {
        this.priceData = res.data.retData;
        this.card_type = res.data.retData.card_type;
        if (res.data.retData.unpay_count > 1) {
          this.dialogVisible = true;
        }
        this.amountList = res.data.retData.amountList;
        this.amount =
          this.currency === "HKD"
            ? (this.amountList[0].amount / 100).toFixed(2)
            : (this.amountList[1].amount / 100).toFixed(2);
        sessionStorage.setItem("amount", this.amount);
      } else {
        this.$message.error(`${res.data.errMsg}`);
      }
    },
    getAmount() {
      this.amount =
        this.currency === "HKD"
          ? (this.amountList[0].amount / 100).toFixed(2)
          : Number(this.amountList[1].amount / 100).toFixed(2);
      sessionStorage.setItem("currency", this.currency);
      sessionStorage.setItem("amount", this.amount);
    },
    async getBankList() {
      let res = await aPost2(api.getBankList);
      if (res.data.errCode === "99999") {
        if (res.data.retData.supp_banks.length > 0) {
          let bankList = res.data.retData.supp_banks;
          let tmp = {};
          this.imageList.forEach((e) => {
            bankList.forEach((ele) => {
              if (ele.iss_inst_code === e.id) {
                tmp = Object.assign({}, ele, e);
                this.bankList.push(tmp);
              }
            });
          });
        }
      }
    },
    /**
     * 聯動支付，跟銀行卡差不多
     */
    async UMPay() {
      // console.log(this.return_url);
      let params = {
        iss_inst_code: "ISS-UMPAY",
        pay_type: "D101",
        channel_code: "UMPAY",
        pay_currency: this.currency,
        order_no: this.order_no,
        return_url: this.return_url,
        pay_bank: "網銀支付"
      };
      let res = await aPost2(api.moneyIn, params);
      if (res.data.errCode === "99999") {
        let html = res.data.retData.redirect_html;
        let win = window.open("", "win");
        win.document.open("text/html", "replace");
        win.document.write(html);
        win.document.close();
      } else {
        this.$notify({
          title: "錯誤",
          message: `訂單狀態異常`,
          type: "error"
        });
      }
    },
    /**
     * 銀行卡支付
     */
    async renew({ iss_inst_code, channel_code, issuer_name }) {
      let params = {
        iss_inst_code,
        pay_type: "D101",
        channel_code,
        pay_currency: this.currency,
        order_no: this.order_no,
        return_url: this.return_url,
        pay_bank: issuer_name
      };
      let res = await aPost2(api.moneyIn, params);
      if (res.data.errCode === "99999") {
        let html = res.data.retData.redirect_html;
        let win = window.open("", "win");
        win.document.open("text/html", "replace");
        win.document.write(html);
        win.document.close();
      } else {
        this.$notify({
          title: "錯誤",
          message: `${res.data.errMsg}`,
          type: "error"
        });
      }
    },
    /**
     * FPS
     *
     */
    async FPSPay() {
      let params = {
        pay_type: "N502",
        pay_currency: this.currency,
        order_no: this.order_no,
        return_url: this.return_url,
        pay_bank: "香港轉數快"
      };
      let res = await aPost2(api.moneyIn, params);
      if (res.data.errCode === "99999") {
        this.$router.push({
          name: "pay",
          params: { payParams: params, payDetail: res.data.retData }
        });
      } else {
        this.$message({
          message: `${res.data.errMsg}`,
          type: "error"
        });
      }
    }
  },

  beforeDestroy() {
    this.bankIndex = 0;
  }
};
</script>

<style lang="scss" scoped>
.bank-list-view {
  margin: 0 auto;
  width: 960px;
  font-size: 16px;
  padding: 40px 0;
  .m-header {
    padding: 10px;
    border: 1px dashed #fa800a;
    .amount {
      margin-right: 10px;
      color: #fa800a;
    }
  }
  .container {
    width: 900px;
    margin: 20px auto 0;
    padding: 16px;
    box-shadow: 0px 0px 1px 1px #ccc;
    .tips {
      color: #999;
      font-size: 12px;
      padding-left: 10px;
    }
    .link {
      color: #1187f5;
    }
    .link:hover {
      cursor: pointer;
      text-decoration: underline;
    }
    .s-header {
      background: #eee;
      padding: 10px;
      position: relative;
      .pipe {
        position: absolute;
        content: "";
        width: 4px;
        height: 100%;
        top: 0;
        left: 0;
        background: #ff6701;
      }
    }
    .t-header {
      padding: 16px 10px 0;
      color: #666;
    }
    .bank-list-card {
      display: flex;
      flex-wrap: wrap;
      .item {
        display: flex;
        align-items: center;
        border: 1px solid #e4e4e4;
        color: #333;
        font-weight: bold;
        line-height: 46px;
        border-radius: 4px;
        width: 180px;
        padding-left: 10px;
        margin-right: 24px;
        margin-bottom: 12px;
      }
      .item:hover {
        cursor: pointer;
      }
      .active {
        border: 1px solid #1187f5;
      }
    }
    .bank-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      padding-bottom: 16px;
      border-bottom: 1px solid #ccc;

      .item {
        display: flex;
        /* justify-content: center; */
        align-items: center;
        width: 174px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #eee;
        cursor: pointer;
        margin-top: 16px;
        margin-left: 6px;
        margin-right: 46px;
        padding-left: 14px;
        box-sizing: border-box;
        span {
          font-size: 14px;
          margin-left: 14px;
        }
      }
      .bank-item {
        width: 25%;
        /* flex: 0 1 25%; */
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
        box-sizing: border-box;
        /* cursor: pointer; */
        .bank-img {
          border-radius: 4px;
          border: 1px solid #eee;
          padding-left: 6px;
          padding-right: 46px;
          cursor: pointer;
          /* padding: 0 10px; */
        }
      }
    }
  }
}
</style>
